import checkIcon from '../images/check.svg'
import whisprLogo from '../images/logo.png'
import ActionButton from './ActionButton'
import '../styles/global.css'
import btnStyles from '../styles/button.module.css'
import { useTranslation } from 'react-i18next'
import '../i18n'

const pageStyles = {
	width: '85%',
	margin: '0 auto',
	maxWidth: '640px',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	paddingTop: '120px'
}

const textStyles = {
	fontSize: 32,
	fontFamily: '"Baloo 2", sans-serif',
	fontWeight: 700,
	paddingTop: 5,
	marginBottom: 30
}

const logoFooterStyles = {
	position: 'absolute',
	bottom: 20,
	right: 25,
	width: '100%',
	textAlign: 'end'
}

const logoStyles = {
	height: 43
}

const MessageSentPage = () => {
	const { t } = useTranslation()

	return (
		<div>
			<main style={pageStyles}>
				<img src={checkIcon} alt='check-icon'></img>
				<div style={textStyles}>{t('messageSentConfirmation')}</div>
				<ActionButton />
				<button
					onClick={() => window.history.back()}
					className={btnStyles['plain-btn']}
				>
					{t('sendAnotherMessage')}
				</button>
			</main>
			<div style={logoFooterStyles}>
				<img src={whisprLogo} alt='whispr-logo' style={logoStyles}></img>
			</div>
		</div>
	)
}

export default MessageSentPage
